import React from "react";
import { MSAL_CONFIG } from "../../common/security/authConfig";
import "../../components/session-expired/SessionExpired.scss"

const SessionExpired = () => {
    React.useEffect(() => {
        sessionStorage.clear();
        localStorage.clear();
    }, []);

    return (
        <div className="session_expired">
            <div className="session_expired-right">
                <div className="session_expired-right-wrapper">
                    <div className="logo">
                        <img src={require("../../../src/common/images/EYLogo.png")} alt="logo" />
                    </div>
                    <div className="section_session_expired">
                        <span>Your session has timed out.</span>
                        <span><a href={MSAL_CONFIG.auth.redirectUri}>Click here</a> to log in again.</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SessionExpired;